var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"home-mav"},_vm._l((_vm.navList),function(item,index){return _c('li',{key:index,class:{active: index == _vm.itemIndex},on:{"click":function($event){return _vm.toPage(item, index)}}},[_vm._v(_vm._s(item.label))])}),0),_vm._v(" "),_c('div',{staticClass:"home-content"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-182891ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 